/* @ngInject */

export default (
  $rootScope,
  $scope,
  $q,
  organizationService,
  changesService,
  uiService,
  OrganizationEnterprise,
  webpage
) => {
  $scope.Model = {
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    organizationService
      .readOrganization({ id: $rootScope.CurrentOrganization.id })
      .then(function (data) {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
          data.enterprise
        );
      })
      .then(function () {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Branding : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = function () {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);

  function saveChanges() {
    var organizationData = {
      id: $rootScope.CurrentOrganization.id,
      enterprise: {
        branding: $rootScope.CurrentOrganization.enterprise.branding
      }
    };
    return organizationService.updateOrganization(organizationData).then(function (result) {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  }
};
